import React, { useState, useEffect } from 'react'
import { useResetPasswordMutation } from '../../Redux/ResetPassword/ResetPasswordSlice'
import Swal from 'sweetalert2'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsForm } from '../../GenericComponents/form'
import { useForm } from 'react-hook-form'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsButton } from '../../GenericComponents/button'
import { passwordValidate } from '../../Utils'
import { getBaseUrl } from '../../Utils'
import InformativeTooltip from '../../GenericComponents/Tooltip/InfoTooltip'
import { useSelector } from 'react-redux'
import { getAppSettings, getAppWorkflowState, RootState, } from '../../Redux/store'
import { encryptData } from '../../GlobalMethods'
import { useTitleContext } from "../../Hooks/useTitleContext";
import PageNotAccessibleIfLoggedIn from './PageNotAcessibleIfLoggedIn'
import { appWorkflowStates } from '../../Types/appWorkflowStates'

declare let window: any
const UnicornApp = window.unicornInstance as any

interface ResetPassword {
    password: string
    confirmPassword: string
    id: string
    tid: string
    linkGuid: string
}

const ResetPasswordForm = () => {
    const appWorkflowState = useSelector((state: RootState) => getAppWorkflowState(state))
    const { setTitle } = useTitleContext();
    setTitle("Reset Password");

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm({
        mode: 'onBlur',  // Changed to onBlur for first interaction
        reValidateMode: 'onChange'  // Keep onChange for subsequent validations
    })

    const [resetPassword, { isLoading }] = useResetPasswordMutation()
    const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state) || {} }
      )
    const [formData, setFormData] = useState<ResetPassword>({
        password: '',
        confirmPassword: '',
        id: '',
        tid: '',
        linkGuid: '',
    })
    const [validationmessage, Setvalidationmessage] = useState('')
    const passwordsMatch = (val: string) => {
        if(val !== '' ){
        if (watch('Resetpassword') != val) {
            return 'Your password and confirm password do not match.'
        }
        else {
            return true
        }
    }
         else {
            return  'Confirm password cannot be empty.'
        }
    }
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target
        setFormData((prev) => ({
            ...prev,
            [id === 'reset_password'
                ? 'password'
                : id === 'reset_confirm_password'
                  ? 'confirmPassword'
                  : id]: value,
        }))
    }

    const handleBlur = (field: string) => {
        if (field === 'Resetpassword') {
            passwordValidate(formData.password, '', '')
        } else if (field === 'ConfirmPassword') {
            passwordsMatch(formData.confirmPassword)
        }
    }
    
    useEffect(() => {
        const hash = window.location.hash
        const queryString = hash.split('?')[1]
        const urlParams = new URLSearchParams(queryString)
        setFormData((prev) => ({
            ...prev,
            id: urlParams.get('id') || '',
            tid: urlParams.get('tid') || '',
            linkGuid: urlParams.get('linkGuid') || '',
        }))
    }, [])

    if (appWorkflowState === appWorkflowStates.UNINITIALIZED  || appWorkflowState === null) {
        return null
    }
    if (appWorkflowState === appWorkflowStates.AUTHENTICATED) {
        return <PageNotAccessibleIfLoggedIn />
    }
    const onSubmit = async (e: React.FormEvent) => {
        try {
            formData.password = encryptData(formData.password,appSettings.PublicEncryptionKey)
            formData.confirmPassword = encryptData(formData.confirmPassword,appSettings.PublicEncryptionKey)
            const response = await resetPassword({ ...formData }).unwrap()
            if (response?.MessageResults?.length) {
                if (response.MessageResults[0].HelpMessage === 0) {
                    Swal.fire({
                        title: 'Reset Password Action Successful!',
                        html: "<p>Password reset successful.</p><p>You'll be redirected to <b>Sign In Page</b> in milliseconds.</p>",
                        timer: 5000,
                        icon: 'success',
                        confirmButtonText: 'Go To Sign In',
                        allowOutsideClick: false,
                        willClose: () => {
                            window.location.href = getBaseUrl() + `/ux/index.html#signin`
                        },
                    })
                } else {
                    Setvalidationmessage(response.MessageResults[0].Message)
                }
            } else {
                throw new Error(response.MessageResults[0].Message)
            }
        } catch (err: any) {
            Swal.fire({
                title: 'Error',
                text: err.message || 'An unexpected error occurred',
                icon: 'error',
            })
        }
    }

    return (
        <div className="row">
            <div className="col-12 offset-sm-2 col-sm-6" id="forgot_password_form_el">
                <div className="row">
                    <div className="col-12 mb-5 text-left">
                        <h2 className="header">Reset Password</h2>
                        <div className="sub-header padding-top-small">Choose a new Password.</div>
                    </div>

                    <div className="col-12">
                        <FoundationsForm
                            id="send_form"
                            handleSubmit={handleSubmit}
                            submitFunction={onSubmit}
                        >
                            <div
                                className={`col-12 ${validationmessage ? 'status-box-compact-error' : ''}`}                               
                                id="status_message"
                            >
                                {validationmessage}
                            </div>

                            <div className="col-12 mb-3">
                                <div className="form-group row" id="reset_password_input_el">
                                    <label
                                        className="col-lg-3 col-xl-3 text-left col-form-label"
                                        htmlFor="reset_password"
                                    >
                                        New Password:
                                    </label>
                                    <div className="col-lg-8 col-xl-9">
                                        <FoundationsInput
                                            type="password"
                                            id="reset_password"
                                            name="reset_password"
                                            inputClasses="form-control"
                                            aria-describedby="passwordHelp"
                                            
                                            inputStyle={{
                                                width: '425px',
                                                padding: '0.4rem',
                                                border: '1px solid rgb(118, 118, 118)',
                                                boxSizing: 'border-box',
                                                marginRight: '10px',
                                                borderRadius: 'unset',
                                                //marginBottom:'10px', //This impacts when the validation message is displayed.

                                            }}
                                            onInput={(e: any) => {
                                                handleInputChange(e)
                                            }}
                                            onBlur={() => handleBlur('Resetpassword')}
                                            toolTipText={
                                                'Password: <ol class="tooltip-help-list"><li>Must be at least 8 letters.</li><li>Must have at least one uppercase letter.</li><li>Must have at least one lowercase letter.</li><li>Must have at least one number.</li><li>Must have at least one special character from ~!@#$%^&amp;*(),.+;:?/</li></ol>'
                                            }
                                            registerFunction={register}
                                            registerName="Resetpassword"
                                            registerRules={{
                                                ...FormValidation.registerPassword,
                                                validate: (val: string) =>
                                                    passwordValidate(val, '', ''),
                                            }}
                                            error={errors.Resetpassword?.message}
                                        ></FoundationsInput>
                                        <span>                                        
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mb-3 col_margin">
                                <div
                                    className="form-group row"
                                    id="reset_confirm_password_input_el"
                                >
                                    <label
                                        className="col-lg-3 col-xl-3 text-left col-form-label"
                                        htmlFor="reset_confirm_password"
                                    >
                                        Confirm Password:
                                    </label>
                                    <div className="col-lg-8 col-xl-8">
                                        <FoundationsInput
                                            type="password"
                                            id="reset_confirm_password"
                                            name="reset_confirm_password"
                                            inputClasses="form-control"
                                            registerFunction={register}
                                            registerName='ConfirmPassword'
                                            registerRules={{
                                                     ...FormValidation.confirmPassword,
                                                 validate: passwordsMatch,
                                            }}
                                            onInput={(e: any) => {
                                                handleInputChange(e)
                                            }}
                                            onBlur={() => handleBlur('ConfirmPassword')}
                                            inputStyle={{
                                                width: '425px',
                                                padding: '0.4rem',
                                                border: '1px solid rgb(118, 118, 118)',
                                                boxSizing: 'border-box',
                                                borderRadius: 'unset',
                                            }}
                                            error={errors.ConfirmPassword?.message}
                                        ></FoundationsInput>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 text-left mb-2 ml-2">
                                <FoundationsButton
                                    type="submit"
                                    id="reset_button_el"
                                    buttonClasses="app-button offset-md-3 col-4"
                                    disabled={false}
                                    customStyle={{ marginLeft: '25%' }}
                                    buttonStyles={{ width:'150px' }}
                                >
                                    Set New Password
                                </FoundationsButton>
                            </div>
                        </FoundationsForm>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResetPasswordForm
